import { Component, Input } from "@angular/core";

@Component({
  selector: "ab-timestamp",
  templateUrl: "./timestamp.component.html",
})
export class TimestampComponent {
  @Input() public time: string;
  @Input() public label: string;
  @Input() public placement: string;
}
